export const FerraraTerraEAcquaGdpr = (config) => {
  const profiling_cookies = config.settings[
    'volto-gdpr-privacy'
  ].defaultPanelConfig.profiling.choices.filter(
    (choice) => choice.config_key !== 'VIMEO',
  );

  config.settings['volto-gdpr-privacy'] = {
    ...config.settings['volto-gdpr-privacy'],
    defaultPanelConfig: {
      ...config.settings['volto-gdpr-privacy'].defaultPanelConfig,

      profiling: {
        ...config.settings['volto-gdpr-privacy'].defaultPanelConfig.profiling,
        choices: [
          ...profiling_cookies,
          // rimossi perchè hanno fatto backtracking sulla volontà di tracciare e profilare
          // {
          //   config_key: 'META',
          //   text: {
          //     it: {
          //       title: 'Facebook e Instagram (prodotti Meta)',
          //       description:
          //         "I cookie di profilazione di Meta permettono di fare analisi di accesso alla pagina e sul comportamento dell'utente, e di mostrarti le pubblicità che potrebbero interessarti di più, solo se sei iscritto a Facebook o Instagram o ad uno dei prodotti di Meta.",
          //     },
          //     en: {
          //       title: 'Meta Cookies',
          //       description:
          //         'Meta profiling cookies and pixel allow you to analyze page access and user behavior, and to show you the advertisements that may interest you the most, only if you are subscribed into Facebook or Instagram or in one of Meta products.',
          //     },
          //   },
          // },
          // {
          //   config_key: 'GOOGLE_ADS',
          //   text: {
          //     it: {
          //       title: 'Google Ads',
          //       description:
          //         "I cookie di profilazione di Google Ads ci permettono di misurare l'efficacia delle campagne pubblicitarie e di mostrarti annunci personalizzati in base alle tue precedenti interazioni con il sito, sui servizi e sulle piattaforme di Google.",
          //     },
          //     en: {
          //       title: 'Google Ads',
          //       description:
          //         'Google Ads profiling cookies allow us to measure the effectiveness of our advertising campaigns and to show you personalized ads based on your previous interactions with the website, across Google services and platforms.',
          //     },
          //   },
          // },
        ],
      },
    },
  };

  return config;
};
